import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "./index.css";
import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { CtaBlock as a } from "@design-system/cta-block";
import { ExtendableImage as i } from "@design-system/extendable-image";
import { HeadingBlock as t } from "@design-system/heading-block";
import c from "classnames";
import { forwardRef as m } from "react";
var n = m(function (_ref, b) {
  var m = _ref.className,
    n = _ref.headingBlock,
    d = _ref.image,
    _ref$align = _ref.align,
    r = _ref$align === void 0 ? "start" : _ref$align,
    o = _ref.ctaBlock,
    _ref$mediaVariant = _ref.mediaVariant,
    g = _ref$mediaVariant === void 0 ? "rounded" : _ref$mediaVariant,
    _ref$tag = _ref.tag,
    l = _ref$tag === void 0 ? "div" : _ref$tag;
  var j = Object.assign(Object.assign({}, n), {
    align: r
  });
  return s(l, Object.assign({
    ref: b,
    className: c("cds-asset-item", m, _defineProperty({}, "cds-asset-item--align-".concat(r), r))
  }, {
    children: [e("div", Object.assign({
      className: "cds-asset-item__content"
    }, {
      children: s("div", Object.assign({
        className: "cds-asset-item__content-inner"
      }, {
        children: [e(t, Object.assign({}, j)), o && e(a, Object.assign({
          align: r
        }, o))]
      }))
    })), d && e("div", Object.assign({
      className: c("cds-asset-item__media", "cds-asset-item__media--".concat(g))
    }, {
      children: e(i, Object.assign({}, d, {
        className: "cds-asset-item__media-image"
      }))
    }))]
  }));
});
export { n as AssetItem };